<template>
  <v-stepper non-linear v-model="aba">
    <v-stepper-header>
      <v-stepper-step editable step="1">Selecione os fornecedores</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="2" :editable="!VERIFICA_FORNECEDOR">Selecione os compradores</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="3" :editable="!VERIFICA_FORNECEDOR && !VERIFICA_COMPRADOR">Confirmação</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-text-field
          class="mb-4"
          v-model="pesquisar.fornecedor"
          outlined
          dense
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        />

        <sys-data-table
          :itemHeight="45"
          item-key="id"
          v-model="fornecedores_selecionados"
          :headers="headers.fornecedores"
          :items="items_tabelas.fornecedores.items"
          :search="pesquisar.fornecedor"
          :height="alturaDaJanela - 300"
          :items-per-page="-1"
          hide-default-footer
          show-select
          dense
          class="mb-3"
          item-class="font-12"
        />

        <v-divider class="my-4"/>

        <v-btn :disabled="VERIFICA_FORNECEDOR" color="primary" @click="aba = 2">Continue</v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-text-field
          class="mb-4"
          v-model="pesquisar.comprador"
          outlined
          dense
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        />

        <sys-data-table
          :itemHeight="45"
          item-key="id"
          v-model="compradores_selecionados"
          :headers="headers.compradores"
          :items="items_tabelas.compradores.items"
          :search="pesquisar.comprador"
          :height="alturaDaJanela - 300"
          :items-per-page="-1"
          hide-default-footer
          single-select
          show-select
          dense
          class="mb-3"
          item-class="font-12"
        />

        <v-divider class="my-4"/>

        <v-btn :disabled="VERIFICA_FORNECEDOR || VERIFICA_COMPRADOR" color="primary" @click="aba = 3">Continue</v-btn>
        <v-btn text @click="aba = 1">Voltar</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-row>
          <v-col>
            <sys-data-table
              :itemHeight="45"
              item-key="id"
              :headers="headers.fornecedores"
              :items="fornecedores_selecionados"
              :search="pesquisar.fornecedor"
              :height="alturaDaJanela - 275"
              :items-per-page="-1"
              hide-default-footer
              dense
              item-class="font-12"
            >
              <template #top>
                <p class="font-weight-bold font-16 ml-2 my-1">Fornecedores Selecionados</p>
                <v-divider />
              </template>
            </sys-data-table>
          </v-col>

          <v-divider vertical />

          <v-col>
            <sys-data-table
              :itemHeight="45"
              item-key="id"
              :headers="headers.compradores"
              :items="compradores_selecionados"
              :search="pesquisar.comprador"
              :height="alturaDaJanela - 275"
              :items-per-page="-1"
              hide-default-footer
              dense
              single-select
              item-class="font-12"
            >
              <template #top>
                <p class="font-weight-bold font-16 ml-2 my-1">Comprador Selecionado</p>
                <v-divider />
              </template>
            </sys-data-table>
          </v-col>
        </v-row>

        <v-divider class="my-4"/>

        <v-btn color="primary" @click="save()" :disabled="VERIFICA_FORNECEDOR || VERIFICA_COMPRADOR">SALVAR</v-btn>
        <v-btn text @click="aba = 2">Voltar</v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import Responsividade from '@/helpers/ResponsiveHeight';
import { editarCompradorMultipoFornecedor } from "@/api/fornecedor";

export default {
  mixins: [Responsividade],
  props: {
    items_tabelas: {
      type: Object,
      required: true,
    },
    dialog: {
      type:Boolean,
      required: true
    },
    selected: Array
  },
  data () {
    return {
      aba: 1,
      pesquisar: {
        fornecedor: '',
        comprador: ''
      },
      headers: {
        fornecedores: [
          { text: 'id', value: 'id' },
          { text: 'Razão Social', value: 'razao_social' },
          { text: 'Nome Comprador Atual', value: 'nome_completo' }
        ],
        compradores: [
          { text: 'id', value: 'id' },
          { text: 'Nome', value: 'nome_completo' }
        ]
      },
      fornecedores_selecionados: [],
      compradores_selecionados: []
    }
  },
  computed: {
    VERIFICA_FORNECEDOR() {
      return this.fornecedores_selecionados.length == 0;
    },
    VERIFICA_COMPRADOR() {
      return this.compradores_selecionados.length == 0;
    }
  },
  mounted() {
    this.passarFornecedor();
  },
  watch: {
    dialog(valor) {
      if (!valor) this.fechar();
    },
    selected() {
      this.passarFornecedor();
    }
  },
  methods: {
    passarFornecedor() {
      this.fornecedores_selecionados = this.items_tabelas.fornecedores.items.filter(filter => {
        return this.selected.includes(filter.id);
      });
    },
    fechar() {
      this.aba = 1;
      this.fornecedores_selecionados = [];
      this.compradores_selecionados = [];
    },
    save() {
      const paramentros = {
        idfornecedor: this.fornecedores_selecionados,
        idcomprador: this.compradores_selecionados
      }

      editarCompradorMultipoFornecedor(paramentros)
        .then(() => {
          this.$emit("fechar-dialog-multiplos-compradores");
          this.fechar();
        })
        .catch(() => this.Helpers.logout())
    }
  }
}
</script>
